<script setup lang="ts">
</script>

<template>
  <main>
    <h1>404</h1>
  </main>
</template>

<style lang="scss" scoped>
  main {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    font-size: 2rem;
  }
  h1 {
    color: #999;
  }
</style>
